// extracted by mini-css-extract-plugin
module.exports = {"hideLoader":"AutoComplete_hideLoader__1QQya","showLoader":"AutoComplete_showLoader__2xwOk"};